import { render, staticRenderFns } from "./create-resource-retrieve.vue?vue&type=template&id=16cd06c0&scoped=true"
import script from "./create-resource-retrieve.vue?vue&type=script&lang=js"
export * from "./create-resource-retrieve.vue?vue&type=script&lang=js"
import style0 from "./create-resource-retrieve.vue?vue&type=style&index=0&id=16cd06c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd06c0",
  null
  
)

export default component.exports